
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pemetaan-kompetensi",
      function () {
        return require("private-next-pages/pemetaan-kompetensi/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pemetaan-kompetensi"])
      });
    }
  